import { Button, Center, Stack, TextInput } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales/index';

import { useAutomationWizardController } from '../controller';

export const Step1 = () => {
  const { t } = useTranslation();
  const {
    form,
    navigation: { goToNextStep, isStep1Valid },
    settings: { getNameFieldProps },
  } = useAutomationWizardController();

  return (
    <Center mt="md">
      <Stack miw="330px">
        <TextInput
          label={t(i18nKeys.AUTOMATION.WIZARD.STEP1.NAME_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.WIZARD.STEP1.NAME_PLACEHOLDER)}
          {...form.getInputProps('name')}
          {...getNameFieldProps()}
        />
        <TextInput
          label={t(i18nKeys.AUTOMATION.WIZARD.STEP1.DESCRIPTION_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.WIZARD.STEP1.DESCRIPTION_PLACEHOLDER)}
          onChange={val => form.setFieldValue('description', val.currentTarget.value)}
          value={form.values.description ?? ''}
        />
        <Button
          w="100%"
          mt="lg"
          disabled={!isStep1Valid()}
          rightSection={<IconArrowRight stroke={1.5} size={20} />}
          onClick={goToNextStep}
        >
          {t(i18nKeys.AUTOMATION.WIZARD.STEP1.NEXT)}
        </Button>
      </Stack>
    </Center>
  );
};
